module.exports = __webpack_public_path__ + "img/11.6d8d3c2b.png";